export const roleConstants = {
GETALL_REQUEST: 'ROLE_GETALL_REQUEST',
GETALL_SUCCESS: 'ROLE_GETALL_SUCCESS',
GETALL_FAILURE: 'ROLE_GETALL_FAILURE',
}
